import { getLocalStorageItem } from "../../utils";
import { User, UserCapabilities } from "./types";

export const USER_SESSION_KEY = "user-session";

export const getUserSessionInfo = (user: User | null) => {
  const now = new Date();
  const currentTime = now.getTime();
  const storedSession = getLocalStorageItem(USER_SESSION_KEY);
  const userSession = storedSession || user;
  const sessionExpirationInMS =
    parseInt(userSession?.authTokenExpiration || "0") * 1000;
  const refreshTokenExpirationInMS =
    parseInt(userSession?.refreshTokenExpiration || "0") * 1000;

  return {
    currentTime,
    storedSession,
    userSession,
    sessionExpirationInMS,
    refreshTokenExpirationInMS,
    isSessionValid: currentTime < sessionExpirationInMS,
    isRefreshTokenValid: currentTime < refreshTokenExpirationInMS,
  };
};

/**
 * Normalize a WP capabilities payload into a `{ cap: boolean }` map.
 * GraphQL login returns `string[]` (caps the user has); `/me` returns the full map.
 */
export const normalizeCapabilities = (
  input: unknown
): UserCapabilities => {
  if (!input) return {};
  if (Array.isArray(input)) {
    return input.reduce<UserCapabilities>((acc, cap) => {
      if (typeof cap === "string") acc[cap] = true;
      return acc;
    }, {});
  }
  if (typeof input === "object") {
    return Object.entries(input as Record<string, unknown>).reduce<UserCapabilities>(
      (acc, [cap, value]) => {
        acc[cap] = !!value;
        return acc;
      },
      {}
    );
  }
  return {};
};
